import { apiGetSmartViewsEntityList, apiGetTask } from "../network/api";
import { constructPayload, getDateRange, getPathPrefix } from "../utils/helper";
import { getAdvancedSearchQuery, getSVTabCode, getTaskType, SMARTVIEW_TYPE_MAPPING_LABELS } from "../utils/widgetHelper";
import { ENITTY, widgetTypes } from "../utils/constants";

export const isListInterfaceAllowed = (type, config, smartviewsConfig, count) => {
  if (!count)
    return false;

  const entity = config?.entity?.id;
  if (entity === ENITTY.TASKS && (type === widgetTypes.ProgressBar || type === widgetTypes.SpeedoMeter || type === widgetTypes.SingleCounter))
    return true;

  else if (entity === ENITTY.SMARTVIEWS && widgetTypes.SingleCounter) {
    const allowedTypes = [
      SMARTVIEW_TYPE_MAPPING_LABELS["LEADS"],
      SMARTVIEW_TYPE_MAPPING_LABELS["OPPORTUNITY"],
      SMARTVIEW_TYPE_MAPPING_LABELS["TASKS"],
    ];

    const tabId = config?.smartViewTab?.id;
    const matchedTab = smartviewsConfig?.tabs?.find(tab => tab.id === tabId);
    const isTypeAllowed = allowedTypes.includes(matchedTab?.type);
    return isTypeAllowed;
  }

  return false;
}

export const contructPayloadForTasks = (config) => {
  let payload = constructPayload({ config });

  if (config?.dateFilters?.id) {
    const dateRange = getDateRange(config.dateFilters.id);
    payload["pageSize"] = 10;
    payload["filters"] = { ...payload.filters, ...dateRange };
  }

  return payload;
}

export const getList = async (config, smartviewsConfig) => {
  const entity = config?.entity?.id;

  if (entity === ENITTY.TASKS) {
    const payload = contructPayloadForTasks(config);
    const { taskList } = await apiGetTask(payload);
    return taskList;
  }

  else if (entity === ENITTY.SMARTVIEWS) {
    const tabId = config?.smartViewTab?.id;
    const matchedTab = smartviewsConfig?.tabs?.find(tab => tab.id === tabId);
    let payload;

    if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["TASKS"]) {
      payload = {
        advancedSearch: getAdvancedSearchQuery(matchedTab),
        pageIndex: 1,
        pageSize: 10,
        type: getTaskType(matchedTab),
        columns: "Name",
      };

      const { taskList } = await apiGetSmartViewsEntityList(payload, ENITTY.TASKS);
      return taskList;
    }

    else if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["OPPORTUNITY"]) {
      payload = {
        advancedSearch: getAdvancedSearchQuery(matchedTab),
        pageIndex: 0,
        pageSize: 10,
        code: getSVTabCode(matchedTab),
        isOpportunity: true,
      };

      const response = await apiGetSmartViewsEntityList(payload, ENITTY.ACTIVITES);
      const list = response?.activityList?.map(item => {
        item["name"] = item["mx_Custom_1"];
        return item;
      });

      return list;
    }

    else if (matchedTab?.type === SMARTVIEW_TYPE_MAPPING_LABELS["LEADS"]) {
      payload = {
        advancedSearch: getAdvancedSearchQuery(matchedTab),
        pageIndex: 0,
        pageSize: 10,
      };

      const response = await apiGetSmartViewsEntityList(payload, ENITTY.LEADS);
      const leadsList = response?.leads?.map(lead => {
        const properties = Object.fromEntries(lead?.leadPropertyList?.map(p => [p?.attribute, p?.value]));
        return {
          leadId: properties.ProspectID,
          name: `${properties?.FirstName || ""} ${properties?.LastName || ""}`.trim() || "[No Name]"
        };
      });

      return leadsList;
    }

    return [];
  }
}

export const handleWidgetClick = (config, id) => {
  let newUrl = new URL(window.location.href);

  const pathPrefix = getPathPrefix('Lead');
  if (config?.entity?.id === "tasks") {
    newUrl.pathname = getPathPrefix('Tasks');
    newUrl.searchParams.set("activeTab", "manage-tasks");
    newUrl.searchParams.set("leadType", config?.objectType?.InternalName);
    newUrl.searchParams.set("dashletId", id);
  } else if (config?.entity?.id === "smartviews") {
    newUrl.pathname = `${pathPrefix}/SmartViews`;
    newUrl.searchParams.set("activeTab", config?.smartViewTab?.id || "");
    newUrl.searchParams.delete("dashletId");
  } else {
    newUrl.pathname = `${pathPrefix}/SmartViews`;
    newUrl.searchParams.set("activeTab", id || ""); // Default case for other widget types
  }

  window.open(newUrl.toString(), "_blank");
};